import { FaPlus } from "react-icons/fa";
import Button from "../../../../components/button/button";
import { Template } from "../../../../components/template/template";
import { Card } from "../../../../components/card/card";
import { AgGridReact } from "ag-grid-react";
import { useQuery } from "@tanstack/react-query";
import IntegrationUsersService from "../../../../services/web/integration-users-service";
import { useMemo, useRef } from "react";
import ProjectUtils from "../../../../utils/project-utils";
import AgGridUtils from "../../../../utils/aggrid-utils";
import ListObjectsCellRenderer from "../../agents/user-list/components/list-objects-cell-renderer";
import { navigateHook } from "../../../../hooks/use-navigate";
import aggridUtils from "../../../../utils/aggrid-utils.js";

export default function IntegrationUsers() {
    const navigate = navigateHook();
    const gridRef = useRef();

    const { data: users = [], isLoading } = useQuery({
        queryKey: ['users'],
        queryFn: IntegrationUsersService.list,
    });

    const columnDefs = useMemo(() => {
        const rolesComparator = (roles) => {
        const arr = Array.isArray(roles) ? roles : (roles ?  [roles] : []);
        return arr
            .map(r => (r?.name || "").trim().toLowerCase())
            .filter(Boolean)
            .sort((a, b) => a.localeCompare(b))
            .join("|");
        };

        return [
            {
                headerName: "Nome",
                headerTooltip: "Nome",
                field: "name",
                tooltipField: "name",
                flex: 2,
                sort: "asc",
                comparator: aggridUtils.lowerUpCaseComparator,
            },
            {
                headerName: "Nome de guerra",
                headerTooltip: "Nome de guerra",
                field: "nameWar",
                tooltipField: "nameWar",
                flex: 2,
                comparator: aggridUtils.lowerUpCaseComparator,
            },
            {
                headerName: "Status",
                headerTooltip: "Status",
                field: "status",
                flex: 1,
                cellRenderer: ({ value }) => value ? "Ativo" : "Inativo",
                tooltipValueGetter: (params) => (params.value ? "Ativo" : "Inativo"),
            },
            {
                headerName: "Último login",
                headerTooltip: "Último login",
                field: "lastLogin",
                flex: 1,
                valueFormatter: (params) =>
                    params.value
                        ? ProjectUtils.formatDate(params.value, "DD/MM/YYYY hh:mm:ss")
                        : "",
                tooltipValueGetter: (params) =>
                    params.value
                        ? ProjectUtils.formatDate(params.value, "DD/MM/YYYY hh:mm:ss")
                        : "",
            },
            {
                headerName: "Funções",
                headerTooltip: "Funções",
                field: "roles",
                flex: 2,
                cellRenderer: ListObjectsCellRenderer,
                tooltipValueGetter: (params) => {
                    const roles = Array.isArray(params.value) ? params.value : (params.value ? [params.value] : []);
                    return roles.map(r => r?.name).filter(Boolean).join(", ");
                },
                comparator: (valueA, valueB) => {
                    const keyA = rolesComparator(valueA);
                    const keyB = rolesComparator(valueB);
                    return keyA.localeCompare(keyB, "pt-BR");
                },
            },
        ];
    }, []);

    const onCellClicked = async ({ data, event }) => {
        const urlDev = `/dev/integration-users/form/${data.id}`;
        let isBlank = !!event.ctrlKey;
        navigate(urlDev, isBlank);
    };

    const newUser = () => {
        const urlDev = `/dev/integration-users/form`;
        navigate(urlDev);
    }
    
    return (
    <>
        <Template isLoading={isLoading}>
            <Template.Header>
                <Template.Title>Usuários de integração</Template.Title>
                <Button onClick={newUser}><FaPlus />Adicionar usuário </Button>
            </Template.Header>
            <Template.Body className="space-y-2 flex flex-col">
                <Card>
                    <Card.Body className="flex">
                        <div className="h-[calc(100vh-91px)] w-full">
                            <AgGridReact
                                ref={gridRef}
                                rowData={users}
                                columnDefs={columnDefs}
                                animateRows={false}
                                suppressCellFocus={true}
                                onCellClicked={onCellClicked}
                                gridOptions={{localeText: AgGridUtils.localization()}}
                                theme={AgGridUtils.generalTheme()}
                                enableBrowserTooltips={true}
                            />
                        </div>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>    
    </>
    )
}